export default __webpack_public_path__ + "static/everton_overlay-cdbb55f601da182ab03f35b57d18051b.png";